// extracted by mini-css-extract-plugin
export default {"modalOverlay":"XJ-z","modalContent":"YJ-z","header":"ZJ-z","close":"_J-z"};